__turbopack_context__.v({
  "bandBody": "typography-module__inU20a__bandBody",
  "body": "typography-module__inU20a__body",
  "cardBody": "typography-module__inU20a__cardBody",
  "cardTitle": "typography-module__inU20a__cardTitle",
  "container": "typography-module__inU20a__container",
  "ctaText": "typography-module__inU20a__ctaText",
  "display": "typography-module__inU20a__display",
  "eyebrow": "typography-module__inU20a__eyebrow",
  "faqAnswer": "typography-module__inU20a__faqAnswer",
  "faqQuestion": "typography-module__inU20a__faqQuestion",
  "geist": "typography-module__inU20a__geist",
  "heading": "typography-module__inU20a__heading",
  "itemTitle": "typography-module__inU20a__itemTitle",
  "lead": "typography-module__inU20a__lead",
  "legal": "typography-module__inU20a__legal",
  "listTitle": "typography-module__inU20a__listTitle",
  "monoButton": "typography-module__inU20a__monoButton",
  "monoMeta": "typography-module__inU20a__monoMeta",
  "pill": "typography-module__inU20a__pill",
  "pillLinedOnDark": "typography-module__inU20a__pillLinedOnDark" + " " + "typography-module__inU20a__pill",
  "pillSolidOnDark": "typography-module__inU20a__pillSolidOnDark" + " " + "typography-module__inU20a__pill",
  "primaryPill": "typography-module__inU20a__primaryPill" + " " + "typography-module__inU20a__ctaText",
  "smallButton": "typography-module__inU20a__smallButton" + " " + "typography-module__inU20a__pill",
  "subtitle": "typography-module__inU20a__subtitle" + " " + "typography-module__inU20a__body",
  "title": "typography-module__inU20a__title" + " " + "typography-module__inU20a__heading",
});
